<template>
	<el-container>
		<el-aside width="200px">
			<el-menu :default-active="activeIndex" class="el-menu-demo" mode="vertical" background-color="#3f3f3f" text-color="#ffffff" unique-opened>
				<router-link v-for="(item,i) in routes" :key="i" :to="item.path">
					<el-submenu :index="i + ''" v-if="item.childrenList" :key="i">
						<template #title>{{ item.meta.title }}</template>
						<router-link v-for="(val,key) in item.childrenList" :key="key" :to="val.path">
							<el-menu-item v-if="!val.meta.hidden" :index="i + '-'+key">{{val.meta.title}}</el-menu-item>
						</router-link>
					</el-submenu>
					<el-menu-item v-if="!item.meta.hidden && !item.childrenList" :index="i + ''">{{item.meta.title}}</el-menu-item>
				</router-link>
			</el-menu>
		</el-aside>
		<el-container>
			<el-header>
				<div>{{$store.state.userName}} | <el-button type="success" style="margin-left: 10px;" @click="loginOut">退出</el-button></div>
			</el-header>
			<el-main>
				<router-view></router-view>
			</el-main>
		</el-container>
	</el-container>
</template>

<script>
	export default{
		data(){
			return{
				activeIndex:"0",
				routes:[]
			}
		},
		watch:{
			$route:{
				handler(newVal){
					this.routes.forEach((e,i)=>{
						if(e.name == newVal.name && (newVal.name != 'latestNewsHide' && newVal.name != 'commonQuestionHide')){
							this.activeIndex = i + ""
						}
						if(e.childrenList){
							e.childrenList.forEach((val,key) => {
								if(val.name == 'latestNews' && newVal.name == 'latestNewsHide'){
									this.activeIndex = i + "-" + key
								}
								if(val.name == 'commonQuestion' && newVal.name == 'commonQuestionHide'){
									this.activeIndex = i + "-" + key
								}
							})
						}
					})
				},
			}
		},
		methods:{
			loginOut(){
				this.$cookies.remove('token')
				this.$router.push({
					path:'/login'
				})
			}
		},
		created() {
			this.$router.options.routes.forEach(e=>{
				if(e.name != 'login'){
					this.routes = e.children
				}
			})
			this.routes.forEach((e,i)=>{
				if(e.name == this.$route.name && (this.$route.name != 'latestNewsHide' && this.$route.name != 'commonQuestionHide')){
					this.activeIndex = i + ""
				}
				if(e.childrenList){
					e.childrenList.forEach((val,key) => {
						if(val.name == 'latestNews' && this.$route.name == 'latestNewsHide'){
							this.activeIndex = i + "-" + key
						}
						if(val.name == 'commonQuestion' && this.$route.name == 'commonQuestionHide'){
							this.activeIndex = i + "-" + key
						}
					})
				}
			})
		}
	}
</script>

<style lang="scss">
	.el-container {
		height: 100vh;
		.el-aside{
			background-color: #3f3f3f;
			.el-menu{
				border-right: none;
			}
		}
		.el-header{
			display: flex;
			padding: 0 20px;
			align-items: center;
			justify-content: flex-end;
			background-color: #1a7fe8;
			color: #ffffff;
		}
	}
</style>
